module.exports = __webpack_public_path__ + "img/naics-tree_example_fr.8a69199b.jpg";